import sharedStyles from 'styles/css/SharedStyles.module.scss';
import formStyles from 'styles/css/FormStyles.module.scss';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleChangeDataPagesMedicalRecords } from "reduxx/actions/pages/user/medicalRecords";
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import { handleChangeProfileData } from 'reduxx/actions/pages/user/login';
import { useEffect } from 'react';
import { EDIT_MEDICAL_RECORDS_3 } from 'apis';
import apiRequest from 'utils/apiRequest';

const EditMedicalRecord3 = () => {

    const dispatch = useDispatch();
	const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.login);
    const { hasDrugAllergy, allergyDrugName } = useSelector(state => state.medicalRecords);

    useEffect(() => {
        dispatch(handleChangeDataPagesMedicalRecords('hasDrugAllergy', profile.medicalRecords.hasDrugAllergy));
        dispatch(handleChangeDataPagesMedicalRecords('allergyDrugName', profile.medicalRecords.allergyDrugName));
    }, [EditMedicalRecord3]);

    const handelChangeInputs = (event) => {
        const {name, value} = event.target;

        if(name === 'hasDrugAllergy')
        	dispatch(handleChangeDataPagesMedicalRecords(name, value === '1'));
        else
        	dispatch(handleChangeDataPagesMedicalRecords(name, value));
    };

    const handleSubmitForm = () => {
    	if(hasDrugAllergy === null)
    		dispatch(handleSetOpenCustomSnackbar(true, {message: 'لطفا حساسیت به دارو را مشخص کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
		else if(hasDrugAllergy && (allergyDrugName === null || allergyDrugName.trim().length === 0) )
			dispatch(handleSetOpenCustomSnackbar(true, {message: 'نام داروهایی که حساسیت دارید را ذکر کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
		else {
			apiRequest({
                dispatch,
                endpoint: EDIT_MEDICAL_RECORDS_3,
                method: 'post',
                data: { hasDrugAllergy: (hasDrugAllergy ? 1 : 0), allergyDrugName },
                token: token,
                successMessage: null,
                onSuccess: (res) => {
                	let newProfile = profile;
                	newProfile.medicalRecords.hasDrugAllergy = hasDrugAllergy;
                	newProfile.medicalRecords.allergyDrugName = allergyDrugName;
                	dispatch(handleChangeProfileData(newProfile));

                    navigate(`/medical-record4`);
                }
            });
		}
    };

    return (
        
        <div className={sharedStyles.container}>

        	<div className={sharedStyles['container-padding']}>
        		<ShortHeaderWithBackBtn />
        		
	            <div className={formStyles.title}>آیا به داروی خاصی حساسیت دارید؟</div>
				<div className={formStyles.radioGroup}>
					<label className={formStyles.radioLabel}><input type="radio" name="hasDrugAllergy" value={0} onChange={handelChangeInputs} checked={hasDrugAllergy === false} /> خیر</label>
					<label className={formStyles.radioLabel}><input type="radio" name="hasDrugAllergy" value={1} onChange={handelChangeInputs} checked={hasDrugAllergy === true} /> بله</label>
				</div>
                { hasDrugAllergy &&
                    <>
    				<div className={formStyles.title}>لطفا نام دارو را ذکر کنید</div>
                    <textarea name="allergyDrugName" value={allergyDrugName} onChange={handelChangeInputs} className={formStyles.descriptionBox} placeholder="نام دارو" />
                    </>
                }
				<button onClick={handleSubmitForm} className={formStyles.button}>تایید</button>
        	</div>

		</div>

    );
}

export default EditMedicalRecord3;